// Lightweight date helpers built on dayjs for consistent formatting/parsing.
// Usage examples:
//   formatDate(value, 'YYYY-MM-DD')
//   toISO(new Date())
//   const d = safeParse(value); if (d) { /* ... */ }

import dayjs from 'dayjs';

// Add plugins here if needed later (utc, timezone, localizedFormat, etc.)
// import utc from 'dayjs/plugin/utc';
// dayjs.extend(utc);

/**
 * Returns formatted string for a given date-like value.
 * If value is null/undefined/invalid, returns an empty string.
 */
export function formatDate(value, format = 'YYYY-MM-DD') {
  if (value === null || value === undefined || value === '') return '';
  const d = dayjs(value);
  return d.isValid() ? d.format(format) : '';
}

/**
 * Returns an ISO-like string for date/time form submissions.
 * Defaults to 'YYYY-MM-DDTHH:mm:ss' to match common backend expectations.
 */
export function toISO(value, withSeconds = true) {
  if (value === null || value === undefined || value === '') return '';
  const d = dayjs(value);
  if (!d.isValid()) return '';
  return d.format(withSeconds ? 'YYYY-MM-DDTHH:mm:ss' : 'YYYY-MM-DDTHH:mm');
}

/**
 * Safely parse a date-like value. Returns a dayjs instance if valid, else null.
 */
export function safeParse(value) {
  const d = dayjs(value);
  return d.isValid() ? d : null;
}

/**
 * Convenience: return formatted output only if the input is valid, else fallback.
 */
export function formatIfValid(value, format, fallback = '') {
  const d = dayjs(value);
  return d.isValid() ? d.format(format) : fallback;
}

export default {
  formatDate,
  toISO,
  safeParse,
  formatIfValid,
};
